<script>
/* import { tableData } from './data-advance' */
import { mapActions } from 'vuex'
import moment from 'moment/moment'
import FormMixin from '@mixins/form'
import applicantProgress from '@components/applicantProgress'
import FeedbackModal from '@components/modals/feedbackModal'
import RejectModal from '@components/modals/rejectModal'
import ScheduleModal from '@components/modals/scheduleModal'
import ResumePdf from '@components/pdf/resumePdf'

export default {
  mixins: [FormMixin],
  components:{applicantProgress, FeedbackModal, RejectModal, ScheduleModal, ResumePdf},
  props:['company', 'settings'],
	data() {
		return {
			title: 'Candidates',
			items: [],
			totalRows: 1,
			currentPage: 1,
			perPage: 20,
			pageOptions: [20, 50, 100, 200],
			filter: null,
			filterOn: [],
			sortBy: '',
			sortDesc: false,
      fields: 
      [
        {
          key: 'full_name',
          label:'Candidate'
        },
        /* {
          key: 'present_company',
          label:'Current Employer'
        }, */
        {
          key: 'job_applying',
          label:'Role Applying'
        },
        {
          key: 'applications',
          label:'Status',
          class: 'text-center'
        },
        {
          key:'date_applied',
          label: 'Date Applied'
        },
        {
          key:'date_interview',
          formatter: (value) => {
            return value ? moment(value).format('YYYY-MM-DD') : 'N/A'
          }
        },
        {
          key:'actions',
          label:''
        }
      ],
      isBusy:false,
      feedbacks:[],
      application_id:'',
      candidate_id:'',
      application:{},
      uiid: '',
      timesData: []
		}
	},
	computed: {
		rows() {
			return this.totalRows
		},
	},
	mounted() {
    this.fetchData()
	},
	methods: {
		...mapActions('candidate', ['paginationCompany', 'getScheduledInterview', 'rejectCandidate', 'getFeedback']),
		onFiltered(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			this.totalRows = filteredItems.length
			this.currentPage = 1
    },
    async addFeedback(item){
      this.application = item
      await this.getFeedback({
        application_id:item._id,
        candidate_id:item.candidate_id._id
      }).then(res => {
        this.feedbacks = res.data
        this.application_id = item._id
        this.candidate_id = item.candidate_id._id
      })
      
      this.$bvModal.show('feedbackModal')
    },
    onReject(item){
      this.application = item
      this.$bvModal.show('reject-modal')
    },
    async fetchData() {
      this.toggleBusy()
      await this.paginationCompany({
        limit:this.perPage,
        start:this.currentPage,
        token:this.$route.query.key
      })
      .then(res => {
        this.totalRows = parseInt(res.data.total, 10)
        this.items = res.data.data
        this.toggleBusy()
      })
    },
    toggleBusy() {
      this.isBusy = !this.isBusy
    },
    toggleViewer(uiid){
      this.$refs.html2Pdf.generateReport(uiid)
    },
    async toggleScheduler(uiid, item){
      this.uiid = uiid
      this.$parent.$data['uiid'] = uiid
      this.application = item
      await this.getScheduledInterview(uiid).then(res => {
        // this.$parent.$data['times'] = res.data
        // var ref = this.$parent.$parent.$refs['scheduler']
        // ref.setTimes(res.data)
        this.timesData = res.data
        // console.log(res)
      })
      this.$bvModal.show('schedule-modal')
      /* document.body.classList.toggle('right-bar-enabled') */
    }
  },
  filters:{
    date:function(v){
      return v ? moment(v).format('MMM DD, YYYY') : 'N/A'
    }
  },
  watch: {
    currentPage: {
      handler: function() {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    },
    perPage: {
      handler: function() {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    },
    filter: {
      handler: function() {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    }
  }
}
</script>
<template>
  <div class="card">
    <div class="card-body">

      <div class="row align-items-center mb-2 pb-2 border-bottom">
        <div class="col">
          <label class="font-weight-bold d-inline mr-2 h4 ">
            <span class="pb-2">{{ title }}</span>
          </label>
        </div>
      </div>

      <div class="row mb-md-2">
        <div class="col-sm-12 col-md-6">
          <div class="dataTables_length">
            <label class="d-inline-flex align-items-center">
              Show&nbsp;
              <b-form-select
                v-model="perPage"
                size="sm"
                :options="pageOptions"
                class="mx-1"
              ></b-form-select
              >&nbsp;entries
            </label>
          </div>
        </div>
        <!-- Search -->
        <div class="col-sm-12 col-md-6">
          <div
            id="tickets-table_filter"
            class="dataTables_filter text-md-right"
          >
            <label class="d-inline-flex align-items-center">
              Search:
              <b-form-input
                v-model="filter"
                type="search"
                placeholder="Search..."
                class="form-control form-control-sm ml-2"
              ></b-form-input>
            </label>
          </div>
        </div>
        <!-- End search -->
      </div>
      <!-- Table -->
      <b-table
        :busy="isBusy"
        :items="items"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
        :show-empty="true"
        responsive
      >

      <template v-slot:table-colgroup="scope">
        <col
          v-for="field in scope.fields"
          :key="field.key"
          :style="{ width: field.key === 'actions' ? '150px' : '' }"
        >
      </template>

        <template v-slot:cell(actions)="row">
  
            <button class="btn btn-soft-primary btn-sm mx-1 mb-1"
              @click="toggleViewer(row.item._id)">
              <i class="uil uil-file-alt"></i>
            </button>

            <button class="btn btn-soft-primary btn-sm mx-1 mb-1"
              v-if="!row.item.rejected && !row.item.confirmed_schedule"
              @click="toggleScheduler(row.item._id, row.item)">
              <i class="uil uil-calender"></i>
            </button>

            <!-- <button class="btn btn-soft-primary btn-sm mx-1 mb-1"
              @click="toggleScheduler(row.item._id)">
              <i class="uil uil-edit"></i>
            </button> -->
            <b-dropdown class="d-inline-block align-top position-absolute"
              variant="outline-primary"
              right
              no-flip
              lazy
              size="sm">
              <template v-slot:button-content>
                <i class="uil uil-ellipsis-h"></i>
              </template>
              <b-dropdown-item @click="addFeedback(row.item)"><i class="uil uil-edit text-warning"></i> Feedback to Candidate</b-dropdown-item>
              <b-dropdown-item @click="onReject(row.item)"><i class="uil uil-ban text-danger"></i> Reject Candidate</b-dropdown-item>
            </b-dropdown>
        </template>

        <template v-slot:cell(full_name)="row">
          <div class="media">
            <img 
              :src="row.item.candidate_id.avatar_path" 
              alt="avatar" 
              class="avatar-sm rounded-circle mr-3">
            <div>
              <div class="h6 m-0">{{row.item.candidate_id.full_name}}</div>
            </div>
          </div>
        </template>


        <template v-slot:cell(applications)="row">
          <div class="text-muted small text-center" v-if="!row.item">
            No Application
          </div>
          <div class="media" v-if="row.item">
            <div class="media-body">
              <!-- <h5 class="mt-0 mb-0 font-size-14">
                <span class="float-right text-muted font-size-12">{{ row.date_applied | custom_date}}</span>
                {{ row.job_id.title }}
              </h5>
              <p class="mt-1 mb-0">
                Client: <span class="text-muted">{{ row.job_id.company_id.name }}</span> 
              </p> -->
              <!-- <span class="text-muted small">{{ row.item.applications[0].job_id.title }}</span> -->
              <applicantProgress 
                statusOnly
                :status="row.item.status"
                :reason="row.item.rejection_reason"
                :applicant="row.item"
              />
            </div>
          </div>
        </template>

        <!-- <template v-slot:cell(avatar)="row">
          <img 
            :src="row.item.avatar_path" 
            alt="avatar" 
            class="avatar-sm rounded-circle mr-3">
        </template> -->

        <template v-slot:cell(date_interview)="row">
          <div v-if="row.item.schedule" class="media">
            <div class="media-body">
              <div> {{ row.item.schedule ? row.item.schedule.date : '' | date}} </div>
              <div class="text-muted small">{{row.item.schedule ? ' (' + row.item.schedule.start_time + ' - ' + row.item.schedule.end_time + ')' : ''}}</div>
            </div>
          </div>
        </template>

        <template v-slot:cell(date_applied)="row">
          <div>{{row.item.date_applied | date}}</div>
        </template>

        <template v-slot:cell(job_applying)="row">
          <div>{{row.item.job_id.title}}</div>
        </template>

      <!--   <template v-slot:cell(present_company)="row">
          <div>{{row.item.candidate_id.present_company}}</div>
        </template>-->
        <template v-slot:table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
        

      </b-table>
      <div class="row">
        <div class="col">
          <div
            class="dataTables_paginate paging_simple_numbers float-right"
          >
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <FeedbackModal 
      :feedbacks="feedbacks"
      :application="application"
    />
    <RejectModal :application="application"/>
    <ScheduleModal :uiid="uiid" :timesData="timesData" :settings="settings" :application="application"/>
    <ResumePdf ref="html2Pdf" :application="application"/>
    
  </div>
</template>
